<!-- <div [ngClass]="{'inputs-are-disabled': !permissions.adj_claim_decision.edit}"> -->

<form [formGroup]="claimsDecisionForm">
  <div>
    <div class="heading-tab">
      <h3 *ngIf="appMetadataHandler.APPCONSTANTS.nbuDefaultState!='proposal_ManualUw'" class="heading">
        <i nz-icon nzType="file-text"></i> Claim Decision</h3>
      <h3 *ngIf="appMetadataHandler.APPCONSTANTS.nbuDefaultState=='proposal_ManualUw'" class="heading">
        <i nz-icon nzType="file-text"></i> Underwriting Decision</h3>
    </div>
    <div class="tab-grid m-t-20">
      <nz-form-item>
        <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('claimDecision')">Decision</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-select nzShowSearch  style="width: 100%" formControlName="claimDecision">
            <nz-option
              *ngFor="let item of (lookup$['manualAdjDecisionCd'] | async) as manualAdjDecisionCd; trackBy:item?.lookupKey"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>

            
          <nz-form-explain
          *ngIf="(claimsDecisionForm.get('claimDecision').dirty || claimsDecisionForm.get('claimDecision').touched) && claimsDecisionForm.get('claimDecision').errors">
          <p style="color:red"
            *ngFor="let error of validationUtilService.getUIErrorList(claimsDecisionForm.get('claimDecision'), CLAIMSDECISIONFORM)">
            {{error.errorMessage || error }}</p>
        </nz-form-explain>




        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Notes/Findings</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <textarea nz-input cols="30" rows="4" placeholder="{{'Enter your notes'| translate}}..."
            formControlName="claimNote"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>


    <ng-container *ngIf="rulesData && rulesData.length > 0">
      <nz-table [nzData]="[1]" [nzShowPagination]="false">
        <thead class="table-header">
          <tr>
            <th class="">Rule Name</th>
            <!-- <th class="">Rule SubType</th>
            <th class="">Decision Type</th> -->
            <th class="">Decision</th>
            <!-- <th class="">Decision Value</th> -->
            <th class="">Weight</th>
            <th class="">Recommendation</th>
          </tr>
        </thead>
        <tbody class="">
          <!-- ruleName,ruleSubType,entityGuid,decisionType,decision,decisionValue -->
          <tr class="table-row" *ngFor="let rule of rulesData">
            <td class="">{{rule.ruleName}}</td>
            <!-- <td class="">{{rule.ruleSubType}}</td>
            <td class="">{{rule.decisionType}}</td> -->
            <td class="">{{rule.decision}}</td>
            <!-- <td class="">{{rule.decisionValue}}</td> -->
            <td class="">{{rule.weight}}</td>
            <td class="">{{rule.recco}}</td>
          </tr>
        </tbody>
      </nz-table>
    </ng-container>

  </div>
</form>